(function ($) {
  // const advantageItem = $('.nodeBedafmeting').find('.nodeBedafmeting__advantage');
  //   advantageItem.each(function (n) {
  //     if(advantageItem.text() == ""){
  //       this.remove();
  //     }
  //     console.log("jaja");
  //   });

  $('.nodeBedafmeting .nodeBedafmeting__advantage:empty').remove();
}(jQuery));
